import React from 'react'
import videoGif from '~/assets/images/video-asset.gif'

import { GifContainer } from './styles'

export const VideoGif = () => {
  return <GifContainer src={videoGif} />
}
